// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7bb1415b","885":"6a29400d"}[chunkId] + ".chunk.js";
};